module["exports"] = [
  "01 #######",
  "01#######",
  "+43-1-#######",
  "+431#######",
  "0#### ####",
  "0#########",
  "+43-####-####",
  "+43 ########"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/phone_number/formats.js
// module id = 822
// module chunks = 1